export enum AgreementAndPolicyType {
  COOKIES = 'cookies',
  PRIVACY_POLICY = 'privacyPolicy',
  TERMS_AND_CONDITIONS = 'termsAndConditions',
}
export interface InitialState {
  policyType: AgreementAndPolicyType | null;
}
